export const errorCodesDataCollectorDescription = "hitGHe";
export default {errorCodesDataCollectorDescription};